import { bunja } from 'bunja';

import { subscribeAccountBunja } from './account';
import { subscribeMarginsBunja } from './margin';
import { subscribeMarketsBunja } from './market';
import { subscribeOrdersBunja } from './order';
import { subscribePositionsBunja } from './position';
import { subscribePswapsBunja } from './pswaps';
import { subscribeSpotMarketsBunja } from './spot-market';
import { subscribeSpotOrdersBunja } from './spot-order';
import { subscribeSpotsBunja } from './spots';
import { subscribeWalletsBunja } from './wallet';

export const subscribeFixedR230522TopicsBunja = bunja(() => {
  // 아래 리소스들은 무조건 처음 한번만 스냅샷이 오고 중간부터 구독하는 것이 불가능하므로 항상 구독하도록 한다.
  // 관련 논의: https://www.notion.so/prextech/WVB-discussion-1adeb32ad227809984a7fe6dbb554e85
  bunja.use(subscribeAccountBunja);
  bunja.use(subscribeMarginsBunja);
  bunja.use(subscribeMarketsBunja);
  bunja.use(subscribeOrdersBunja);
  bunja.use(subscribePositionsBunja);
  bunja.use(subscribePswapsBunja);
  bunja.use(subscribeSpotMarketsBunja);
  bunja.use(subscribeSpotOrdersBunja);
  bunja.use(subscribeSpotsBunja);
  bunja.use(subscribeWalletsBunja);
});
subscribeFixedR230522TopicsBunja.debugLabel = 'subscribeFixedR230522TopicsBunja';
